import React from 'react'
import { Box, CheckboxIcon, Tooltip, UnstyledButton } from '@mantine/core'

import { StepStatus } from './CrFormStep'

const LABEL: Record<StepStatus, string> = {
  unchecked: 'Validate and mark this step done',
  done: 'Step complete — click to edit again',
  invalid: 'This step has fields that need fixing',
}

// Circular status control, sized/colored to match the NewScript timeline checkbox
// (indigo, filled when done). Adds an orange invalid state the script flow lacks.
export const StepStatusControl: React.FC<{
  status: StepStatus
  onClick: () => void
}> = ({ status, onClick }) => (
  <Tooltip label={LABEL[status]} openDelay={400} withinPortal>
    <UnstyledButton
      onClick={onClick}
      aria-label={LABEL[status]}
      sx={theme => ({
        width: 24,
        height: 24,
        borderRadius: '50%',
        border: '2px solid',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(status === 'done' && {
          backgroundColor: theme.colors.indigo[7],
          borderColor: theme.colors.indigo[7],
          color: theme.white,
        }),
        ...(status === 'unchecked' && {
          backgroundColor: 'white',
          borderColor: theme.colors.indigo[7],
          color: theme.colors.indigo[7],
          '&:hover': { backgroundColor: theme.colors.indigo[0] },
        }),
        ...(status === 'invalid' && {
          backgroundColor: 'white',
          borderColor: theme.colors.orange[6],
          color: theme.colors.orange[7],
          '&:hover': { backgroundColor: theme.colors.orange[0] },
        }),
      })}
    >
      {status === 'done' && (
        <Box sx={{ width: 15 }}>
          <CheckboxIcon indeterminate={false} />
        </Box>
      )}
      {status === 'invalid' && (
        <span style={{ fontWeight: 700, fontSize: 14, lineHeight: 1 }}>!</span>
      )}
    </UnstyledButton>
  </Tooltip>
)
